import React from 'react';

import { Button } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

import { LbTabs, LbUnderlineTabsList } from '../../../../shared/components/tabs';
import { useVideosManagementContext } from '../hooks/useVideosManagement';
import { PageTitle } from '../../../../shared/components/ui-components';

const AddVideoPageTitle = () => {
  const { selectedCategory, changeSelectedCategory, openAddVideoModal, categoryOptions } =
    useVideosManagementContext();

  return (
    <LbTabs
      value={selectedCategory}
      onValueChange={(value) => changeSelectedCategory(value as string)}
    >
      <PageTitle
        title="Videos"
        tabs={<LbUnderlineTabsList tabsConfig={categoryOptions} />}
      >
        <Button
          variant="contained"
          size="medium"
          onClick={openAddVideoModal}
          startIcon={<AddRoundedIcon />}
        >
          Add New Video
        </Button>
      </PageTitle>
    </LbTabs>
  );
};

export { AddVideoPageTitle };
